const flags = {
  state: 'active',
  global: {
    kibana: {
      enabled: 'true',
    },
    showCPPFooter: 'true',
    xapInterstitial: 'true',
    xapSoftDisco: 'false',
    flexPromo: 'false',
    peacockPromo: 'false',
    enableLinkedAccountManagement: 'true',
    showCovidMessages: 'false',
    xapExitEnabled: 'true',
    channelTracking: 'true',
    enablePrepaidSettings: 'true',
    collections2: 'true',
    enableRewardsTab: 'true',
  },
  'bill-pay': {
    kibana: {
      enabled: 'true',
    },
    consent: {
      enabled: 'true',
      ecobill: 'true',
      acceptedContracts: 'false',
    },
    paymentSetup: {
      enabled: 'true',
    },
    p2pMessaging: 'true',
    xapExitPlanEnabled: 'true',
    applePayEnabled: 'true',
    applePayApiUpgradeEnabled: 'true',
    enableGlobalNav: 'true',
    forceGlobalNav: 'true',
    auth15Disabled: 'false',
    stepUpEnabled: 'false',
    txnDataTokenizationEnabled: 'false',
    txnDataPaymentEnabled: 'false',
    plaidEnabled: 'false',
    enhancedCpcLoggingEnabled: 'true',
    nowResumeEnhancements: 'true',
    unifiedWalletEnabled: 'false',
  },
  'maw-fe-ng': {
    kibana: {
      enabled: 'true',
    },
    nbas: {
      covidUbb: 'false',
      xapExitPaymentPlanEligible: 'true',
      xapExitPaymentPlanInProgress: 'true',
      xapExitPaymentPlanEnrolled: 'true',
    },
    twoStepVerificationEnabled: 'true',
    enableDevicesHeroHeader: 'true',
    enableElevatedIssueDetection: 'true',
    scheduledProcessingMessaging: 'true',
    enableBmUid: 'true',
    enableServicePolicyNotifications: 'true',
    inboxEmailStatus: 'true',
    deviceSwapCta: 'true',
    deviceSwapNba: 'true',
    cottonSikOrderEnabled: 'true',
    disableNonDigitalReturnsNba: 'true',
    moveBillDueDate: 'true',
    v4PaymentApi: 'true',
    orderHubServiceModule: 'true',
    orderHubProInstall: 'true',
    orderHubInStore: 'true',
    flexOrderHub: 'true',
    enableCPPRollout: 'true',
    enableP2P: 'true',
    enablePendingCredits: 'true',
    enableSmsEnrollOutageNBA: 'false',
    useSSMTimeline: 'true',
    ieCancelLink: 'true',
    ubbChargeAmount: 'true',
    adPrefsExtraMaineCopy: 'true',
    showCovidUbbBanner: 'true',
    enableCreditEligibility: '100',
    decommissionAdvertisingSettings: 'true',
    orderConfirmations: 'true',
    enableGetStartedKit: 'true',
    disableDotComRedirect: 'true',
    enableNED: 'false',
    newFriendlyBillSummary: 'true',
    caBriteMessageEnabled: 'true',
    enableOutageLob: 'true',
    enableOutageNotificationOnDeviceTile: 'false',
    removeCancelTextIE: 'true',
    enableXfinityRewards: 'true',
    enableXfinityRewardsMarketing: 'true',
    iePlanLink: 'false',
    legacyBritebill: 'false',
    enableSSMQueryDSM: 'true',
    enableGlobalNav: 'true',
    d2SettingsPageEnabled: 'true',
    chosenName: 'true',
    forceGlobalNav: 'true',
    legalContractsEnabled: 'false',
    servicesRedirectEnabled: 'false',
    newRequiredNoticesEnabled: 'false',
  },
  appointments: {
    kibana: {
      enabled: 'true',
    },
    disableAppointments: 'false',
    disableWaitlist: 'false',
    enableCRTicketing: 'true',
    showCovidInstallCopy: 'true',
    xapInterstitial: 'false',
    enableGlobalNav: 'true',
    forceGlobalNav: 'true',
    sroEnabled: 'true',
  },
  users: {
    kibana: {
      enabled: 'true',
    },
    confirmRemoveMfaDevice: 'false',
    disableSuspend: 'true',
    enableDeletedUsers: 'false',
    enableNotificationFlags: 'true',
    enableProfanityValidation: 'false',
    enableProfanityValidationInvite: 'false',
    isVerified: '0',
    displayOptOut: 'true',
    enableGlobalNav: 'true',
    forceGlobalNav: 'true',
  },
  'device-returns': {
    kibana: {
      enabled: 'false',
    },
    disableOrders: 'false',
    enableXfinityStore: 'true',
    upsCallForPickup: 'true',
    enableHomeDevices: 'true',
    disableNonDigitalReturns: 'false',
    xapInterstitial: 'false',
    returnsDisabled: 'false',
    recommendUps: 'false',
  },
  devices: {
    kibana: {
      enabled: 'true',
    },
    xapInterstitial: 'false',
    enableGlobalNav: 'true',
    forceGlobalNav: 'true',
    cottonFeatureEnabled: 'true',
    cottonAccountApiEnabled: 'true',
    cottonOauthEnabled: 'true',
    cottonMacaroonEnabled: 'false',
    cottonSwapsOrdersEnabled: 'false',
    cottonSwapsOrderEnabled: 'false',
    cottonSwapsEligibilityEnabled: 'false',
    cottonDeviceStatusEnabled: 'false',
    cottonHicEnabled: 'false',
    cottonDsmDevicesEnabled: 'false',
    cottonDsmReturnsEnabled: 'false',
    cottonDsmReturnsLabelEnabled: 'false',
    cottonConsolidatedOutageLob: 'false',
    cottonDsmReturnsNewLabelEnabled: 'false',
    cottonOutageEnabled: 'false',
    cottonCmsSupportEnabled: 'false',
    cottonInternetUsageEnabled: 'false',
    cottonInternetPlanEnabled: 'false',
    disableRubyApis: 'true',
    isAptV1Enabled: 'true',
    useSsmDeviceStatus: 'true',
    disableNonDigitalReturnsNba: 'true',
    enableSmsEnrollOutageNBA: true,
    enableOutageLob: true,
    enableElevatedIssueDetection: false,
  },
};
export default flags;
